import { IElement } from '@studio/domain/creativeset';

export function findElementIndex(elements: IElement[], elementIdToFind: string | undefined): number {
    if (!elementIdToFind) {
        return -1;
    }
    return elements.findIndex(({ id }) => id === elementIdToFind);
}
